import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { DueDateSpan } from "../../EnquiryList.styled";
import { DivBackgroundOpacity } from "@utils/extra-style";
import { getDateFormat } from "@utils/datePickerUtils";

const CreationDate = (props) => {
  const { t, data, type } = props;
  const [colorClass, setColorClass] = useState("#32A728");

  useEffect(() => {
    if (type === "dueDate") {
      let currentDate = new Date();
      const newCurrentDate = new Date();
      currentDate = currentDate.setDate(currentDate.getDate() + 1);

      const dueDateTIme = new Date(data.dueDateFormat).getTime();

      if (dueDateTIme > currentDate) {
        setColorClass("#32A728");
      }
      if (currentDate === dueDateTIme || newCurrentDate > dueDateTIme) {
        setColorClass("#F08046");
      }
      if (newCurrentDate > dueDateTIme) {
        setColorClass("#E83F1E");
      }
    }
  }, [type]);

  return (
    <>
      <DivBackgroundOpacity opacity={data?.isActive === 1 ? 1 : "0.2"}>
        {type === "creation" && getDateFormat(data.date, "YYYY-MM-DD")}
        {type === "dueDate" && (
          <DueDateSpan color={colorClass}>
            {getDateFormat(data.date, "YYYY-MM-DD")}
          </DueDateSpan>
        )}
      </DivBackgroundOpacity>
    </>
  );
};

CreationDate.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CreationDate);
